const [d,l] = [document,location]
const pathname = l.pathname.replace(/index\.php|index\.html/,'');

export default class CURRENT_NAV {
  constructor( query='[data-plugin="currentNav"]' ){
    this.query = query;
    d.addEventListener('DOMContentLoaded', this.init.bind(this) )
    
  }

  init() {
    const containers = d.querySelectorAll(this.query);
    Array.prototype.forEach.call(containers, container => {
      this.scan( container.querySelectorAll('a[href]') )
      const max_depth = container.dataset.maxdepth || 3;
      let i=2;
      while(max_depth >= i){
        this.scan( container.querySelectorAll('a[href]'),i )
        i++
      }
    })

  }

  scan (items, depth=1 ){
    items.forEach(item => {
      let href = item.getAttribute('href').replace(/https?:/,'');
      let cond = (pathname == '/' && href==l.origin.replace(/https?:/,''))? '\\/': href.replace(/(http:|https:)?\/\//,'').replace(l.host,'');
      switch( depth ){
        case 1: cond = `^${cond.replace('/','\/')}$`; break
        case 2: cond = `^${cond.replace('/','\/')}([^/]+\/)$`; break
        case 3: cond = `^${cond.replace('/','\/')}([^/]+\/)([^/]+\/)$`; break
      }
      const regex = new RegExp( cond );
      if(regex.test(pathname) && depth == 1) item.classList.add(`current`);
      else if(regex.test(pathname)) {
        item.classList.add(`is-l${depth}-current`);
      }
    });

  }
}